import React, {useEffect, useRef, useState} from 'react';
import PopupSelectAdapter from "../PopupSelectAdapter";
import PropTypes from "prop-types";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import PopupOptions from "../popup_select_component/PopupOptions";
import LinkForPopup from './link_implement/JobSearchOrdersTypesPopupLink';
import {fetchPopupData} from "../popup_select_component/fetchPopupData";
import PopupSelect from "../PopupSelect";
import ReactDOM from "react-dom";

const JobSearchOrdersTypesSearcher = props => {
  const [jobSearchOrderIds, setJobSearchOrderIds] = useState(props.job_search_order_ids);
  const [shouldSubmit, setShouldSubmit] = useState(false);

  useEffect(() => {
    if (shouldSubmit) {
      $('form').submit();
    }
  },[shouldSubmit]);

  const url = (() => {
    const path = '/popup/job_search_orders_types';
    const data = {
      selected_ids: jobSearchOrderIds.split(","),
      is_limited_item: 0
    };
    return path + '?' + (new URLSearchParams(data)).toString();
  })();

  const onClosePopup = selectedJobSearchOrderTypes => {
    setJobSearchOrderIds(selectedJobSearchOrderTypes.map(job_search_order => job_search_order.id).join(','));
  };

  const onSubmit = () => {
    setShouldSubmit(true);
  };

  const onChangejobSearchOrderIds = event => {
    setJobSearchOrderIds(event.target.value);
  };

  useEffect(() => {
    const handleCategoryChange = () => {
      const selectedRadio = document.querySelector('input[id="radio-02"]:checked');
      if (selectedRadio) {
        setJobSearchOrderIds(""); // カテゴリが変更されたらsetJobSearchOrderIdsを空にする
        document.querySelector('input[name="input_job_search_order_name"]').value = "";
      }
    };

    document.addEventListener('change', handleCategoryChange);

    return () => document.removeEventListener('change', handleCategoryChange);
  }, []);

  return (
    <>
      <PopupSelectAdapter
        popupOptions={PopupOptions.recruitmentPrTypes}
        fetchedData={fetchPopupData(url)}
        needSelectedAllButton={false}
        rootNode={document.querySelector('#popup_member_job_search_order')}
        onClosePopup={onClosePopup}
        onSubmit={onSubmit}
        selectedNames={props.input_job_search_order_name}
        LinkForPopup={LinkForPopup}
        ButtonArea={ButtonArea}
      />
      <input type="hidden"
             name="q[custom_search_job_search_order_id]"
             onChange={onChangejobSearchOrderIds}
             value={jobSearchOrderIds}
      />
    </>
  );
};

JobSearchOrdersTypesSearcher.propTypes = {
  job_search_order_ids: PropTypes.string,  // ie. "1,2,3"
  input_job_search_order_name: PropTypes.string  // ie. "name1/name2/name3"
};

const ButtonArea = props => {
  return (
    <>
      <a className="back select-job_search_order-btn" onClick={props.onClickCloseButton}>他の条件を選択</a>
      <a className="search search-job_search_order-btn" onClick={props.onClickSubmitButton}>この条件で検索</a>
    </>
  );
};

export default JobSearchOrdersTypesSearcher;
